export default "__VITE_ASSET__BFoNYuMy__"